import { useMemo } from 'react';

// useNivoCharts hook
const useNivoCharts = ({ decimals = 2, colorScheme = 'nivo', legendPosition = 'bottom-right' } = {}) => {
    // Function to round numbers to specified decimals
    const roundValue = (value) => parseFloat(value).toFixed(decimals);

    // Default tooltip formatting function
    const defaultTooltip = ({ point }) => (
        <div style={{ padding: '5px', background: '#fff', border: '1px solid #ccc' }}>
            <strong>{point.serieId}</strong>
            <br />
            x: {roundValue(point.data.x)}  {/* Apply rounding here */}
            <br />
            y: {roundValue(point.data.y)}% {/* Apply rounding here */}
        </div>
    );

    // Reusable legend settings
    const defaultLegendSettings = useMemo(() => ([
        {
            anchor: legendPosition, // Use legendPosition parameter
            direction: 'column',
            justify: false,
            translateX: legendPosition.includes('right') ? 100 : 0,
            translateY: legendPosition.includes('bottom') ? 0 : 50,
            itemsSpacing: 0,
            itemDirection: 'left-to-right',
            itemWidth: 80,
            itemHeight: 20,
            itemOpacity: 0.75,
            symbolSize: 12,
            symbolShape: 'circle',
            effects: [
                {
                    on: 'hover',
                    style: {
                        itemOpacity: 1
                    }
                }
            ]
        }
    ]), [legendPosition]);

    // Common chart settings that can be shared
    const commonSettings = useMemo(() => ({
        colors: { scheme: colorScheme },
        useMesh: true,
        tooltip: defaultTooltip, // Use the default tooltip with rounding
        theme: {
            tooltip: {
                container: {
                    background: '#ffffff',
                    color: '#333',
                    fontSize: '12px',
                    borderRadius: '2px',
                    boxShadow: '0 3px 9px rgba(0, 0, 0, 0.15)',
                },
            },
        },
        legends: defaultLegendSettings, // Include the legend settings here
    }), [colorScheme, decimals, defaultLegendSettings]);

    return {
        roundValue,
        commonSettings,
    };
};

export default useNivoCharts;
